import { useEffect, useState } from "react";
import api from "../../../utils/api";
import SingleData from "./singleData";
import "./unpaidCard.css";

const UnpaidCard = () => {
  const [newData, setNewData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/feesreport");
        const dataList = response?.data?.data;
        setNewData(Array.isArray(dataList) ? dataList : []);
      } catch (error) {
        console.error("Failed to fetch fees report:", error);
        setNewData([]);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="unpaid_card">
      <h3>Unpaid Student Intuition</h3>
      <h6>You have {Array.isArray(newData) ? newData.length : 0} contacts</h6>
      <div></div>
      {Array.isArray(newData) && newData.length > 0
        ? newData?.map((data) => <SingleData data={data} key={data?.id || Math.random()} />)
        : <p>No unpaid student data found.</p>
      }
    </div>
  );
};

export default UnpaidCard;
